import axiosPost from '../axiosPost';

export const tiposDeRegistroIns = async (arg) => {
    const { nombre, codigo } = arg;

    const body = {
        "service": "TipoDeRegistroIns",
        "params": {
            "tipoRegistroNombre": nombre,
            "tipoRegistroCod": codigo
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}